<template>
  <div :class="['container_PFormSelect', classReadOnly]">
    <div class="label_PFormSelect" v-if="label !== ''" @click="open">
      {{ label }}
    </div>

    <ValidationProvider :rules="rules" v-slot="{ valid, errors }">
      <input type="text" v-model="valueLocal" v-show="false" />
      <p-drop-down-container v-model="pussOption" :alwaysOpen="onlyOptions" :alwaysClose="readonly">
        <template v-slot:content v-if="!onlyOptions">
          <div class="inputSelect_PFormSelectMulti">
            <PIcon
              :icon="icon"
              :type="iType"
              :size="iSize"
              :color="iColor"
              v-if="icon !== ''"
              class="iconLeft_PFormSelectMulti"
            ></PIcon>
            <div
              class="inputSelectedContainer_PFormSelectMulti"
              :class="{ 'selected-items-scroll': scroll }"
            >
              <div v-if="selectedTexts.length === 0">{{ placeholder }}</div>
              <div
                class="inputSelected_PFormSelectMulti"
                v-for="(selectedText, index) in selectedTexts"
                :key="index + ''"
                @click.stop="unSelectedItem(selectedText)"
              >
                <span
                  :class="{ 'text-over': showTextOver }"
                  :title="showTextOver ? giveMeTextOption(selectedText) : ''"
                >
                  {{ giveMeTextOption(selectedText) }}
                </span>
                <PIcon icon="close" type="material" class="closeIcon__PFormSelectMulti"></PIcon>
              </div>
            </div>

            <div class="expand_moreSelect">
              <PIcon icon="expand_less" type="material" color="#ffd102" v-if="pussOption"></PIcon>
              <PIcon icon="expand_more" type="material" color="#ffd102" v-else></PIcon>
            </div>
          </div>
        </template>
        <template #default v-if="!readonly">
          <div :class="['optionsSelect_PFormSelectMulti', classOnlyOptions]" v-if="!group">
            <PFormInputText
              v-model="valueSearch"
              v-if="(pussOption || onlyOptions) && options.length > 5"
              icon="search"
              itype="material"
              class="p_input_search"
              ref="inputSearch"
            />
            <div
              v-for="(option, index) in optionsFiltering"
              :key="index"
              @click="selectItem(option[optionValue])"
              :class="giveMeClass(option[optionValue])"
            >
              <span
                v-if="optionSubText !== ''"
                v-b-tooltip.hover.left.d300="onlyOptions ? option[optionText][optionSubText] : ''"
                >{{ option[optionText][optionSubText] }}</span
              >
              <span v-else v-b-tooltip.hover.left.d500="onlyOptions ? option[optionText] : ''">{{
                option[optionText]
              }}</span>
            </div>
          </div>
          <div :class="['optionsGroupSelect_PFormSelectMulti', classOnlyOptions]" v-if="group">
            <PFormInputText
              v-model="valueSearch"
              v-if="(pussOption || onlyOptions) && totalOptionsCount > 4"
              icon="search"
              itype="material"
              class="p_input_search"
              ref="inputSearch"
            />
            <div v-for="(optionGroup, index) in optionsFiltering" :key="index + 'group'">
              <div class="group_PFormSelectMulti" @click="selectGroup(optionGroup)">
                <slot name="group">
                  {{ optionGroup.name }}
                </slot>
              </div>
              <div
                v-for="(option, index2) in optionGroup.items"
                :key="index2 + 'itemsGroup'"
                @click="selectItem(option[optionValue])"
                :class="['itemGroup_PFormSelectMulti', giveMeClass(option[optionValue])]"
              >
                <span
                  v-if="optionSubText !== ''"
                  v-b-tooltip.hover.left.d300="onlyOptions ? option[optionText][optionSubText] : ''"
                  >{{ option[optionText][optionSubText] }}</span
                >
                <span v-else v-b-tooltip.hover.left.d500="onlyOptions ? option[optionText] : ''">{{
                  option[optionText]
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </p-drop-down-container>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && invalid_feedback !== ''"
      >
        {{ invalid_feedback }}
      </div>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && invalid_feedback === ''"
      >
        {{ $t(errors[0]) }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SelectGroupType } from "@/components/look";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "../PIcon/PIcon.vue";
import PFormInputText from "@/components/look/PFormInput/PFormInputText.vue";

@Component({
  components: {
    PDropDownContainer,
    PIcon,
  },
})
export class PFormSelectMulti extends Vue {
  @Prop({ required: true }) value!: string[];
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = structuredClone(this.value);
  }
  @Prop({ required: true }) options!: any | SelectGroupType[];
  @Watch("options", { immediate: true, deep: true })
  onChangePussOptions(): void {
    this.valueSearch = "";
  }
  @Prop({ required: false, default: false }) group!: boolean;
  @Prop({ required: false, default: false }) scroll!: boolean;
  @Prop({ required: false, default: false }) showTextOver!: boolean;
  @Prop({ required: false, default: "value" }) optionValue!: string;
  @Prop({ required: false, default: "text" }) optionText!: string;
  @Prop({ required: false, default: "" }) optionSubText!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: "Select an option" }) placeholder!: string;
  @Prop({ required: false, default: "" }) icon!: string;
  @Prop({ required: false, default: "" }) iType!: string;
  @Prop({ required: false, default: 16 }) iSize!: number;
  @Prop({ required: false, default: "#6f6f6f" }) iColor!: string;
  @Prop({ required: false, default: undefined }) rules!: string;
  @Prop({ required: false, default: "" }) invalid_feedback!: string;
  @Prop({ required: false, default: false }) onlyOptions!: boolean;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: undefined }) max!: number;
  @Prop({ required: false, default: false }) actionOpen!: boolean;
  @Watch("pussOption", { immediate: true, deep: true })
  onChangePussOption(): void {
    if (this.pussOption) {
      this.$nextTick(() => {
        (this.$refs.inputSearch as PFormInputText)?.$el.querySelector("input")?.focus();
      });
    } else {
      this.valueSearch = "";
    }
  }
  valueLocal: unknown[] = [];
  pussOption = false;
  valueSearch = "";

  get optionsFiltering(): any[] {
    if (this.group) {
      return this.options
        .map((group: any) => {
          const filteredItems = group.items.filter((item: any) =>
            (item[this.optionText] || "")
              ?.toLowerCase()
              .normalize("NFD")
              .replaceAll(/\p{Diacritic}/gu, "")
              .includes(this.valueSearch.toLowerCase())
          );
          return { ...group, items: filteredItems };
        })
        .filter((group: any) => group.items.length > 0);
    }

    return this.options.filter(
      (opt: any) =>
        opt[this.optionText]?.toLowerCase().includes(this.valueSearch.toLowerCase()) ||
        opt[this.optionText]
          ?.toLowerCase()
          .normalize("NFD")
          .replaceAll(/\p{Diacritic}/gu, "")
          .includes(this.valueSearch.toLowerCase())
    );
  }

  get selectedTexts(): unknown[] {
    if (this.valueLocal.length > 0) {
      return this.valueLocal;
    } else {
      return [];
    }
  }
  get optionsComp(): any[] {
    if (this.group) {
      //Aqui sacamos todos los grupos y ponemos todos los items juntos para seguir la logica de selecionar los item
      let returnTemp: unknown[] = [];
      this.options.forEach((option: SelectGroupType) => {
        returnTemp = returnTemp.concat(option.items);
      });
      return returnTemp;
    } else {
      return this.options;
    }
  }
  get classOnlyOptions(): string {
    if (this.onlyOptions) {
      return "optionsOnlyOptions_PFormSelectMulti";
    } else {
      return "";
    }
  }
  get classReadOnly(): string {
    if (this.readonly) {
      return "inputSelectReadonly_PFormSelectMulti";
    } else {
      return "";
    }
  }
  get totalOptionsCount(): number {
    if (this.group) {
      return this.options.reduce((acc: number, group: any) => acc + (group.items?.length || 0), 0);
    } else {
      return this.options.length;
    }
  }

  giveMeTextOption(selectedText: unknown): unknown {
    const optionSelected: any = this.optionsComp.find(
      (op: any) => op[this.optionValue] == selectedText
    );
    if (optionSelected) {
      if (this.optionSubText === "") {
        return optionSelected[this.optionText];
      } else {
        return optionSelected[this.optionText][this.optionSubText];
      }
    }
    return selectedText;
  }
  selectGroup(group: SelectGroupType): void {
    let isAllSelected = true;
    group.items.forEach((item) => {
      if (
        !this.valueLocal.some((vt) => JSON.stringify(vt) == JSON.stringify(item[this.optionValue]))
      ) {
        isAllSelected = false;
      }
    });
    group.items.forEach((item) => {
      this.selectItem(item[this.optionValue], !isAllSelected);
    });
  }
  selectItem(itemValue: unknown, soloSeleccionar?: boolean): void {
    if (!this.valueLocal.some((vt) => JSON.stringify(vt) == JSON.stringify(itemValue))) {
      if (!this.max || this.max > this.valueLocal.length) {
        this.valueLocal.push(itemValue);
        this.$emit("input", this.valueLocal);
        this.$emit("change", this.valueLocal);
      }
    } else if (!soloSeleccionar) {
      this.unSelectedItem(itemValue);
      this.$emit("input", this.valueLocal);
      this.$emit("change", this.valueLocal);
    }
  }
  unSelectedItem(itemValue: unknown): void {
    this.valueLocal.splice(this.valueLocal.indexOf(itemValue), 1);

    this.$emit("input", this.valueLocal);
    this.$emit("change", this.valueLocal);
  }
  giveMeClass(itemValue: unknown): string {
    if (this.valueLocal.some((vt) => JSON.stringify(vt) == JSON.stringify(itemValue))) {
      return "itemSelectSelected_PFormSelectMulti";
    } else {
      return "itemSelect_PFormSelectMulti";
    }
  }
  open(): void {
    if (this.actionOpen && !this.readonly) {
      this.pussOption = !this.pussOption;
    }
  }
}
export default PFormSelectMulti;
</script>
<style lang="scss" scoped>
.inputSelectReadonly_PFormSelectMulti {
  opacity: 0.7;
}

.selected-items-scroll {
  max-height: 50px;
  overflow-y: auto;
  overflow-x: hidden;
}

.inputSelect_PFormSelectMulti {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  padding: 4px 10px 4px 10px;
  color: #807f7f;
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  min-height: 45px;
  align-items: center;
}
.iconLeft_PFormSelectMulti {
  padding-right: 5px;
  margin-top: -3px;
}
.optionsGroupSelect_PFormSelectMulti,
.optionsSelect_PFormSelectMulti {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.optionsOnlyOptions_PFormSelectMulti {
  height: 230px;
}
.inputSelectedContainer_PFormSelectMulti {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
}
.itemSelect_PFormSelectMulti,
.itemSelectSelected_PFormSelectMulti,
.filter_options {
  padding: 0 1rem;
  border-bottom: solid 1px rgba(151, 151, 151, 0.13);
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: normal;
  cursor: pointer;
  white-space: nowrap;
}
.itemSelectSelected_PFormSelectMulti {
  color: #d7b000;
}
.itemSelect_PFormSelectMulti:hover {
  background-color: rgba(151, 151, 151, 0.13);
}
.inputSelected_PFormSelectMulti {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-left: 10px;
  justify-content: space-between;
  background-color: #f7f7f7;
  padding: 3px;
  border-radius: 6px;
}

.expand_moreSelect span {
  font-size: 18px !important;
  margin-left: 5px;
}
.closeIcon__PFormSelectMulti {
  font-size: 15px;
  margin-top: -2px;
  padding-left: 8px;
}
.label_PFormSelect {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
  cursor: pointer;
}
.p_form_invalid_feedback {
  color: #dc3545;
  font-size: 0.7rem;
}
.group_PFormSelectMulti {
  padding-left: 1rem;
  padding-top: 1rem;
  font-weight: bold;
  cursor: pointer;
}
.group_PFormSelectMulti:hover {
  opacity: 0.3;
  font-weight: bold;
  cursor: pointer;
}
.itemGroup_PFormSelectMulti {
  padding-left: 2rem;
}
.alwaysOpen_PDropDownContainer .itemSelect_PFormSelectMulti > span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter_options {
  border: 0 none;
}
.text-over {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 315px;
}
.p_input_search {
  position: sticky;
  top: 0;
}
</style>
